import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Editor from "../../../components/admin/Editor";
import "./AddProduct.css";
import { BACKEND_URL } from "../../../config";

function AddProduct() {

  const navigate = useNavigate();

  // ================= FORM DATA =================

  const [formData, setFormData] = useState({
    productName: "",
    slug: "",
    sku: "",
    date: "",

    category_id: "",
    section: "",
    shortDescription: "",
    description: "",

    metaTitle: "",
    metaDescription: "",

    manufacturer: "",
    composition: "",

    shipTime: "",

    status: "Active",
  });

  // ================= AUTO SLUG =================

  useEffect(() => {

    const generatedSlug = formData.productName
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-");

    setFormData((prev) => ({
      ...prev,
      slug: generatedSlug,
    }));

  }, [formData.productName]);

  // ================= COMMON CHANGE =================

  const handleChange = (e) => {

    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ================= STATES =================

  const [categories, setCategories] = useState([]);

  const [keywordInput, setKeywordInput] = useState("");
  const [keywordList, setKeywordList] = useState([]);

  const [imagePreview, setImagePreview] = useState(null);
  const [file, setFile] = useState(null);

  const [saving, setSaving] = useState(false);

  // ================= FAQ =================
  // FAQ ab keyword jaisa "locked after add" flow follow karta hai.
  // faqList = saved/locked FAQs (read-only cards)
  // faqInput = abhi typing wali ek active Question + Answer pair

  const [faqList, setFaqList] = useState([]);

  const [faqInput, setFaqInput] = useState({
    question: "",
    answer: "",
  });

  // ================= PACK PRICING =================

  const [packPricing, setPackPricing] = useState([
    {
      packSize: "",
      unit: "",
      price: "",
      unitPerPrice: "",
    },
  ]);

  // ================= CATEGORY FETCH =================

  useEffect(() => {

    fetch(`${BACKEND_URL}/api.php?module=category`)
      .then((res) => res.json())
      .then((data) => {

        if (data.success && Array.isArray(data.data)) {
          setCategories(data.data);
        } else {
          setCategories([]);
        }
      })
      .catch((err) => console.log(err));

  }, []);

  // ================= PACK HANDLER =================

  const handlePackChange = (index, field, value) => {

    setPackPricing((prev) => {

      const updated = [...prev];

      updated[index] = {
        ...updated[index],
        [field]: value,
      };

      const size = parseFloat(updated[index].packSize);
      const price = parseFloat(updated[index].price);

      updated[index].unitPerPrice =
        size && price
          ? (price / size).toFixed(2)
          : "";

      return updated;
    });
  };

  const addPackRow = () => {

    setPackPricing([
      ...packPricing,
      {
        packSize: "",
        unit: "",
        price: "",
        unitPerPrice: "",
      },
    ]);
  };

  const removePackRow = (index) => {

    setPackPricing(
      packPricing.filter((_, i) => i !== index)
    );
  };

  // ================= FAQ =================

  const handleFaqInputChange = (field, value) => {

    setFaqInput((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const addFaq = () => {

    const question = faqInput.question.trim();
    const answer = faqInput.answer.trim();

    if (!question || !answer) {

      alert("Please fill both Question and Answer");

      return;
    }

    setFaqList((prev) => [
      ...prev,
      {
        question,
        answer,
      },
    ]);

    // input clear ho jayega, jaise keyword input clear hota hai

    setFaqInput({
      question: "",
      answer: "",
    });
  };

  const removeFaq = (index) => {

    setFaqList(
      faqList.filter((_, i) => i !== index)
    );
  };

  // ================= KEYWORDS =================

  const handleKeywordKeyDown = (e) => {

    if (e.key === "," || e.key === "Enter") {

      e.preventDefault();

      const value = keywordInput.trim();

      if (value && !keywordList.includes(value)) {

        const updated = [...keywordList, value];

        setKeywordList(updated);
      }

      setKeywordInput("");
    }
  };

  const removeKeyword = (index) => {

    setKeywordList(
      keywordList.filter((_, i) => i !== index)
    );
  };

  // ================= SUBMIT =================

  const handleSubmit = async (e) => {

    e.preventDefault();

    setSaving(true);

    if (!formData.productName.trim()) {

      alert("Product name required");

      setSaving(false);

      return;
    }

    if (!formData.category_id) {

      alert("Please select category");

      setSaving(false);

      return;
    }

    if (!formData.section) {

      alert("Please select section");

      setSaving(false);

      return;
    }

    const validPackPricing = packPricing.filter(
      (p) => p.packSize && p.price
    );

    try {

      const form = new FormData();

      form.append("productName", formData.productName);
      form.append("slug", formData.slug);
      form.append("sku", formData.sku);
      form.append("date", formData.date);

      form.append("category_id", formData.category_id);

      form.append(
        "section",
        formData.section
      );

      form.append(
        "shortDescription",
        formData.shortDescription
      );

      form.append(
        "description",
        formData.description
      );

      form.append(
        "metaTitle",
        formData.metaTitle
      );

      form.append(
        "metaDescription",
        formData.metaDescription
      );

      form.append(
        "manufacturer",
        formData.manufacturer
      );

      form.append(
        "composition",
        formData.composition
      );

      form.append(
        "shipTime",
        formData.shipTime
      );

      form.append(
        "status",
        formData.status
      );

      form.append(
        "keywords",
        keywordList.join(",")
      );

      form.append(
        "faq",
        JSON.stringify(faqList)
      );

      form.append(
        "packPricing",
        JSON.stringify(validPackPricing)
      );

      // IMAGE

      if (file) {
        form.append("image", file);
      }

      const response = await fetch(
        `${BACKEND_URL}/api.php?module=product`,
        {
          method: "POST",
          body: form,
        }
      );

      const text = await response.text();

      console.log("RAW RESPONSE:", text);

      let result;

      try {

        result = JSON.parse(text);

      } catch (err) {

        console.error("Invalid JSON:", text);

        alert("Backend error");

        return;
      }

      if (result.success) {

        alert("Product added successfully ✔");

        navigate("/admin/products/view");

      } else {

        alert(
          result.message || "Error saving product"
        );
      }

    } catch (err) {

      console.error(err);

      alert("Network error");

    } finally {

      setSaving(false);
    }
  };

  // ================= UI =================

  return (

    <div className="add-product-page">

      <h2>Add Product</h2>

      <form onSubmit={handleSubmit}>

        {/* PRODUCT NAME */}

        <input
          type="text"
          name="productName"
          placeholder="Product Name"
          value={formData.productName}
          onChange={handleChange}
          required
        />

        {/* SLUG */}

        <input
          type="text"
          name="slug"
          placeholder="Slug"
          value={formData.slug}
          onChange={handleChange}
        />

        {/* SKU */}

        <input
          type="text"
          name="sku"
          placeholder="SKU"
          value={formData.sku}
          onChange={handleChange}
        />

        {/* DATE */}

        <input
          type="date"
          name="date"
           placeholder="Select Date"
          value={formData.date}
          onChange={handleChange}
        />
        {/* CATEGORY */}

        <select
          name="category_id"
          value={formData.category_id}
          onChange={handleChange}
          required
        >
          <option value="">
            Select Category
          </option>

          {categories.map((c) => {
            const pId = c.parentId || c.parent_id;
            const parent = (pId && pId !== "0" && pId !== 0) ? categories.find((p) => String(p.id) === String(pId)) : null;
            const displayName = parent ? `${parent.categoryName} > ${c.categoryName}` : c.categoryName;
            return (
              <option
                key={c.id}
                value={c.id}
              >
                {displayName}
              </option>
            );
          })}
        </select>

        {/* SECTION */}

        <select
            name="section"
            value={formData.section}
            onChange={handleChange}
            required
          >
            <option value="">
              Select Section
            </option>

            <option value="bestseller">
              Bestseller
            </option>

            <option value="new-launch">
              New Launch
            </option>

            <option value="most-searched">
              Most Searched
            </option>
          </select>

        {/* PACK PRICING */}

        <h3>Pack Pricing</h3>

       {packPricing.map((item, index) => (
        <div className="pack-row" key={index}>

            <input
              type="number"
              placeholder="Pack Size"
              value={item.packSize}
              onChange={(e) =>
                handlePackChange(
                  index,
                  "packSize",
                  e.target.value
                )
              }
            />

            <input
              type="text"
              placeholder="Unit"
              value={item.unit}
              onChange={(e) =>
                handlePackChange(
                  index,
                  "unit",
                  e.target.value
                )
              }
            />

            <input
              type="number"
              placeholder="Price"
              value={item.price}
              onChange={(e) =>
                handlePackChange(
                  index,
                  "price",
                  e.target.value
                )
              }
            />

            <input
              type="text"
              placeholder="Unit Price"
              value={item.unitPerPrice}
              disabled
            />

            <button
              type="button"
              onClick={() =>
                removePackRow(index)
              }
            >
              Remove
            </button>

          </div>
        ))}

        <button
          type="button"
          onClick={addPackRow}
        >
          + Add Pack Size
        </button>

        {/* MANUFACTURER */}

        <input
          name="manufacturer"
          placeholder="Manufacturer"
          value={formData.manufacturer}
          onChange={handleChange}
        />

        {/* COMPOSITION */}

        <input
          name="composition"
          placeholder="Composition"
          value={formData.composition}
          onChange={handleChange}
        />

        {/* SHORT DESCRIPTION */}

        <h3>Short Description</h3>

        <Editor
          formData={formData}
          setFormData={setFormData}
          field="shortDescription"
        />

        {/* DESCRIPTION */}

        <h3>Description</h3>

        <Editor
          formData={formData}
          setFormData={setFormData}
          field="description"
        />

        {/* META TITLE */}

        <input
          name="metaTitle"
          placeholder="Meta Title"
          value={formData.metaTitle}
          onChange={handleChange}
        />

        {/* META DESCRIPTION */}

        <textarea
          name="metaDescription"
          placeholder="Meta Description"
          value={formData.metaDescription}
          onChange={handleChange}
        />

        {/* KEYWORDS */}

        <input
          placeholder="Keywords"
          value={keywordInput}
          onChange={(e) =>
            setKeywordInput(e.target.value)
          }
          onKeyDown={handleKeywordKeyDown}
        />

        <div className="keyword-container">
          {keywordList.map((k, i) => (

            <span
            key={i}
            className="keyword-tag"
            onClick={()=>removeKeyword(i)}
            >
            {k} 
            </span>

            ))}
        </div>

        {/* FAQ */}

        <div>

          <h3>FAQ</h3>

          {/* SAVED / LOCKED FAQs - jaise keyword tag */}

          {faqList.map((item, index) => (

            <div className="faq-box" key={index}>

              <strong>Q: {item.question}</strong>

              <span>A: {item.answer}</span>

              <button
                type="button"
                className="remove-btn"
                onClick={() =>
                  removeFaq(index)
                }
              >
                Remove
              </button>

            </div>
          ))}

          {/* ACTIVE INPUT - sirf ek hi pair, jaise keyword input */}

          <div className="faq-box">

            <input
              placeholder="Question"
              value={faqInput.question}
              onChange={(e) =>
                handleFaqInputChange(
                  "question",
                  e.target.value
                )
              }
            />

            <input
              placeholder="Answer"
              value={faqInput.answer}
              onChange={(e) =>
                handleFaqInputChange(
                  "answer",
                  e.target.value
                )
              }
            />

          </div>

          <button
            type="button"
            onClick={addFaq}
          >
            + Add FAQ
          </button>

        </div>

        {/* IMAGE */}

        <input
          type="file"
          accept=".webp,image/webp"
          onChange={(e) => {

            const file = e.target.files[0];

            if (file) {

              if (file.type !== "image/webp") {

                alert(
                  "Only WEBP images are allowed "
                );

                return;
              }

              setFile(file);

              setImagePreview(
                URL.createObjectURL(file)
              );
            }
          }}
        />

        {imagePreview && (
          <img
            src={imagePreview}
            width="200"
            alt=""
          />
        )}

        {/* SHIP TIME */}

        <input
          name="shipTime"
          placeholder="Ship Time"
          value={formData.shipTime}
          onChange={handleChange}
        />

        {/* STATUS */}

        <select
          name="status"
          value={formData.status}
          onChange={handleChange}
        >
          <option>Active</option>
          <option>Inactive</option>
        </select>

        {/* SUBMIT */}

        <button
          type="submit"
          disabled={saving}
        >
          {saving
            ? "Saving..."
            : "Add Product"}
        </button>

      </form>

    </div>
  );
}

export default AddProduct;
